import React from "react";
import { useTranslation } from "react-i18next";
import ClubEvents from "./ClubEvents";

const ClubEventsModal = ({ club, onClose, onRefresh }) => {
  const { t } = useTranslation("clubs");

  if (!club) return null;

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-calendar-alt me-2"></i>
              {t("manageEventsTitle", { name: club.name })}
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <ClubEvents club={club} onClose={onClose} onRefresh={onRefresh} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClubEventsModal;
